'use client';
import './styles/default.scss';
import { useEffect, useState } from 'react';

export const ChasingLights = ({ children }: { children: React.ReactNode }) => {
    const [animationShouldStart, setAnimationShouldStart] = useState(false);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setAnimationShouldStart(true);
        }, 1000);

        return () => {
            clearTimeout(timeoutId);
        };
    }, []);

    return (
        <div className="chasing__lights--container">
            {animationShouldStart && (
                <>
                    <div className="chasing__lights--white-line"></div>
                    <div className="chasing__lights--separator"></div>
                    <div className="chasing__lights--separator chasing__lights--separator-opposite"></div>
                    <div className="chasing__lights--lights"></div>
                    <div className="chasing__lights--content">{children}</div>
                </>
            )}
        </div>
    );
};
